import { gql } from '@apollo/client';

export const INSTRUCTOR_UPDATE = gql`
    mutation patchInstructor( $input: PatchInstructorInput! ) {
        patchInstructor( input: $input ) {
                id
                companyId
                name
                description
                title
                emailAddress
                createdAt
                updatedAt
        }
    }
`;

export default INSTRUCTOR_UPDATE;
